import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3481 10.3128C13.7807 11.0627 13.2376 12 12.3736 12H1.12627C0.260561 12 -0.279954 11.0612 0.151811 10.3128L5.77555 0.562149C6.20837 -0.188062 7.29242 -0.186703 7.72447 0.562149L13.3481 10.3128ZM6.75001 8.29688C6.15458 8.29688 5.67188 8.77957 5.67188 9.375C5.67188 9.97043 6.15458 10.4531 6.75001 10.4531C7.34544 10.4531 7.82813 9.97043 7.82813 9.375C7.82813 8.77957 7.34544 8.29688 6.75001 8.29688ZM5.72642 4.42158L5.90028 7.60908C5.90841 7.75823 6.03174 7.875 6.18111 7.875H7.3189C7.46827 7.875 7.5916 7.75823 7.59973 7.60908L7.77359 4.42158C7.78238 4.26047 7.65411 4.125 7.49276 4.125H6.00723C5.84588 4.125 5.71763 4.26047 5.72642 4.42158Z",
		fill: "#F5222D"
	})
});
const ForwardRef = forwardRef(SvgError);
export { ForwardRef as ReactComponent };
